const config = {
    baseURL: "https://backend.inkimos.com",
    // baseURL: "http://localhost:3004",
};
  
export default config;
  